export const useProductHistory = () => useNuxtApp().$history
